import { useTransactionInitializationStore } from "../../stores/useTransactionInitializationStore";

export const useBeneficiaryList = () =>
    useTransactionInitializationStore(state => state.beneficiaryList);

export const useOriginalBeneficiaryList = () =>
    useTransactionInitializationStore(state => state.originalBeneficiaryList);

export const useCategoryList = () =>
    useTransactionInitializationStore(state => state.categoryList);

export const useItemList = () =>
    useTransactionInitializationStore(state => state.itemList);

export const useItemPerCategoryList = () =>
    useTransactionInitializationStore(state => state.itemsPerCategoryList);

export const usePaymentTypeList = () =>
    useTransactionInitializationStore(state => state.paymentTypeList);

export const useCurrencyList = () =>
    useTransactionInitializationStore(state => state.currencyList);

export const useStoreEmployeeList = () =>
    useTransactionInitializationStore(state => state.storeEmployeeList);

export const useCostCenterList = () =>
    useTransactionInitializationStore(state => state.costCenterList);

export const useCalcTypeList = () =>
    useTransactionInitializationStore(state => state.calcTypeList);

export const useStoreList = () =>
    useTransactionInitializationStore(state => state.storeList);

export const useIsSalesComponent = () =>
    useTransactionInitializationStore(state => state.isSalesComponent);

export const useHasSingleStore = () =>
    useTransactionInitializationStore(state => state.hasSingleStore);

export const useDefaultStoreId = () =>
    useTransactionInitializationStore(state => state.defaultStoreId);

export const useIsTransactionLoaded = () =>
    useTransactionInitializationStore(state => state.isLoaded);

export const useTransactionLoading = () =>
    useTransactionInitializationStore(state => state.loading);
